import { useCallback } from 'react';
import { AndroidSoftInputModes, KeyboardController, } from 'react-native-keyboard-controller';
import useFocusEffect from './useFocusEffect';
export const useKeyboardAdjustPan = () => {
    useFocusEffect(useCallback(() => {
        // Android only; a no-op on iOS and web.
        KeyboardController.setInputMode(AndroidSoftInputModes.SOFT_INPUT_ADJUST_PAN);
        return () => {
            // Default value, specified in AndroidManifest.xml
            KeyboardController.setDefaultMode();
        };
    }, []));
};
